import { Card } from "./Card";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

export class OuterPile extends Phaser.Group {

    public static COLLISION_CIRCLE_RADIUS: number = 32;

    public pileX: number;
    public pileY: number;
    public pileAngle: number;
    public i: number;
    
    private dx: number;
    private dy: number;
    private easing: Function;
    private bottomCard: Card;
    private highlightSprite: Phaser.Sprite;
    
    constructor(game: Phaser.Game, x: number, y: number, angle: number, i: number) {

        super(game, null, "outer-pile");
        
        this.pileX = x;
        this.pileY = y;
        this.pileAngle = angle;
        
        this.i = i;
        
        // parameters for the shuffle animation
        var sign: number = this.i % 2 === 0 ? 1 : -1;
        this.easing =  this.i % 2 === 0 ?  Phaser.Easing.Cubic.In :  Phaser.Easing.Cubic.Out;
            
        this.dx =  - sign * 1.1 * GameConstants.CARD_HEIGHT * Math.sin(this.pileAngle / 180 * Math.PI);
        this.dy = sign * 1.1 * GameConstants.CARD_HEIGHT * Math.cos(this.pileAngle / 180 * Math.PI);
        
        if (GameConstants.SHOW_BOUNDING_AREAS) {
            var boundingCircle: Phaser.Image = new Phaser.Image(this.game, this.pileX, this.pileY , "texture_atlas_0", "outer-pile-bounding-circle.png");
            boundingCircle.anchor.setTo(.5, .5);
            this.addChild(boundingCircle);
        }
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        super.destroy(destroyChildren, soft);
    }

    public update(): void {

        super.update();
    }
    
    public addCard(card: Card, startGame?: boolean, tween?: boolean): void {
        
        if (!startGame) {
            
            if (tween) {
                
                Card.cardTweening = true;
                
                this.game.add.tween(card)
                    .to({x: this.pileX , y: this.pileY }, 300 , Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function(): void{
                        Card.cardTweening = false;
                        this.add(card);
                    }, this);
                
                this.game.add.tween(card)
                    .to({angle: this.pileAngle }, 300 , Phaser.Easing.Cubic.Out, true);
                
            } else {
                
                card.x = this.pileX;
                card.y = this.pileY;
                card.angle = this.pileAngle;
                
                this.add(card);
            }
            
        } else {
            
            card.x = 0;
            card.y = 700;
            card.angle = this.pileAngle;
            this.add(card);
        }

        card.outerPileIndex = this.i;
        card.foundationPileIndex = -1;
    }
    
    public returnCardToPile(card: Card): void {
        
        card.x = this.pileX;
        card.y = this.pileY;
        card.angle = this.pileAngle;
    }
    
    public shuffle(): number {
                
        if (this.length < 2) {
            return 0;
        }
        
        this.bottomCard = <Card> this.getBottom();
        
        this.game.add.tween(this.bottomCard)
            .to({x: this.pileX + this.dx , y: this.pileY + this.dy }, 275 , this.easing, true, this.i * 75)
            .onComplete.add(function(): void {

                    this.bringToTop(this.bottomCard);
                    this.game.add.tween(this.bottomCard)
                    .to({x: this.pileX , y: this.pileY }, 275 , this.easing, true);
                    
                    
                    var rnd: number = Math.random();
                    var sound: string;
                    
                    if (rnd < .4) {
                    sound = "cardfeed_1";
                    } else if (rnd < 7) {
                    sound = "cardfeed_2";
                    } else {
                    sound = "cardfeed_3";
                    }
                    
                    AudioManager.getInstance().playSound(sound);
                    
            }, this);
            
        // las escalamos tambien
        this.game.add.tween(this.bottomCard.scale)
                .to({x: 1.075 , y: 1.075 }, 275 , this.easing, true, this.i * 75, 0, true);
                
        return (275 + this.i * 75 + 275);
    }
    
    public showHint(): Phaser.Sprite {
        
        this.highlightSprite = this.create(this.pileX, this.pileY, "texture_atlas_2", "highlight0001.png");
        this.highlightSprite.anchor.setTo(.5, .5);
        this.highlightSprite.angle = this.pileAngle;
        this.add(this.highlightSprite);
        
        this.highlightSprite.animations.add("highlight", Phaser.Animation.generateFrameNames("highlight", 1, 12, ".png", 4));
        this.highlightSprite.animations.play("highlight", 20, true);
        
        return this.highlightSprite;
    }
    
    public getValueUpperCard(): CardValue {
        
        var upperCard: Card = <Card> this.getTop();
        
        if (upperCard) {
                return upperCard.cardValue;
        } else {
            return null;
        }
    }
    
    public getUpperCard(): Card {
        
        const upperCard: Card = <Card> this.getTop();
        
        if (upperCard) {
            return upperCard;
        } else {
            return null;
        }
    }
}

